import { render, staticRenderFns } from "./IconAlertTriangle.vue?vue&type=template&id=111deef6"
import script from "./IconAlertTriangle.vue?vue&type=script&lang=js"
export * from "./IconAlertTriangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports